import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "slider" }
const _hoisted_2 = ["title"]

import { computed } from 'vue';
import { useAreaContext } from '../context';


export default /*@__PURE__*/_defineComponent({
  __name: 'left-slider',
  props: {
    activeTab: {}
  },
  setup(__props: any) {



const { model } = useAreaContext()!


const provinceName = computed(() => {
  if (model.province) return model.province.districtName
  return '省份'
})

const cityName = computed(() => {
  if (model.city) return model.city.districtName
  return '城市'
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['slider-tab', { active: _ctx.activeTab === 'province' }]),
      title: provinceName.value
    }, _toDisplayString(provinceName.value), 11, _hoisted_2),
    _createElementVNode("div", {
      class: _normalizeClass(['slider-tab', { active: _ctx.activeTab === 'city' }])
    }, _toDisplayString(cityName.value), 3)
  ]))
}
}

})